import { LoadingButton } from '@mui/lab';
import { Button, CircularProgress } from '@mui/material';

import Dialog from 'Lib/muiComponents/dialog/Dialog';

export default function DeleteDialog({ children, fullWidth = false, deleteText = 'Delete', isDeleting, title = 'Delete', onDelete, open, toggle }) {
	return (
		<Dialog
			fullWidth={fullWidth}
			open={open}
			title={title}
			toggle={toggle}
			onClose={toggle}
			maxWidth="xs"
			actions={() => (
				<>
					<Button variant="outlined" color="success" onClick={toggle} sx={{ mr: 2 }}>
						Cancel
					</Button>
					<LoadingButton
						loading={isDeleting}
						variant="contained"
						color="error"
						onClick={onDelete}
						sx={{ boxShadow: 'none' }}
						loadingIndicator={<CircularProgress color="error" size={16} />}>
						{deleteText}
					</LoadingButton>
				</>
			)}>
			{children}
		</Dialog>
	);
}
